import styled from "styled-components";
import Width from "../Width";
import { useState } from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import PolicyPdfDialog from "../PolicyPdfDialog";

const FooterBlock = styled.div`
  width: 100%;
  font-size: 12px;
  padding-top: 40px;
  color: #999;
  margin-bottom: 80px;
`;

const FooterAmComponent = () => {
  const year = new Date().getFullYear();
  const [policyPopup, setPolicyPopup] = useState(false);
  const { t } = useTranslation();

  return (
    <FooterBlock>
      <Width>
        <Box>© 2011 – {year} Freedom Finance Armenia LLC</Box>

        <Box sx={{ my: 1 }}>
          <Button
            onClick={() => setPolicyPopup(true)}
            variant="text"
            sx={{ px: 0, textTransform: "none", fontSize: "12px" }}
            size="small"
          >
            {t("footer.privacyPolicy")}
          </Button>
        </Box>

        <p>{t("footer.riskDisclosureAM")}</p>
      </Width>

      <PolicyPdfDialog
        open={policyPopup}
        onClose={() => setPolicyPopup(false)}
        company="Freedom Finance Armenia LLC"
      />
    </FooterBlock>
  );
};

export default FooterAmComponent;
